import { inject } from 'vue'

import { formatterProviderKey } from '../../../../constants'
import { defaultFormatter } from '../../../../formatters'

export const useDetailFormatters = () => {
  const { formatNumber, formatDateTimeLong, formatMoney } = inject(
    formatterProviderKey,
    defaultFormatter,
  )
  const formatInteger = (value: number | null | undefined, showZero = false) => {
    if (value == null || (!value && !showZero)) {
      return '—'
    }
    return formatNumber(Number(value))
  }
  const formatPercent = (value: number | null | undefined, showZero = false) => {
    if (value == null || (!value && !showZero)) {
      return '—'
    }
    return `${formatNumber(Number(value))}%`
  }
  return { formatNumber, formatDateTimeLong, formatMoney, formatInteger, formatPercent }
}
